import { Mail, Linkedin, Phone, Facebook, Send } from 'lucide-react';
import { FaInstagram } from 'react-icons/fa';

export default function Contact({ darkMode }) {
  const contacts = [
    {
      label: 'Email',
      value: 'risecap212@gmail.com',
      href: 'mailto:risecap212@gmail.com',
      icon: <Mail size={18} />,
    },
    {
      label: 'Mobile',
      value: '+91 9821097136',
      href: 'tel:9821097136',
      icon: <Phone size={18} />,
    },
    {
      label: 'LinkedIn',
      value: 'linkedin.com/in/manojpant991123',
      href: 'https://www.linkedin.com/in/manojpant991123/',
      icon: <Linkedin size={18} />,
    },
    {
      label: 'Instagram',
      value: 'risecap_finance',
      href: 'https://www.instagram.com/risecap_finance/?hl=en',
      icon: <FaInstagram size={18} />,
    },
    {
      label: 'Facebook',
      value: 'RiseCap',
      href: 'https://www.facebook.com/profile.php?id=100093338240391',
      icon: <Facebook size={18} />,
    },
  ];

  const inputClass = (darkMode) =>
    `w-full px-4 py-3 rounded-xl text-sm border outline-none transition-all duration-200
    focus:ring-2 focus:ring-[#C9A84C]/30 focus:border-[#C9A84C]
    ${darkMode
      ? 'bg-[#0A0F1E] border-[#C9A84C]/15 text-white placeholder-gray-600'
      : 'bg-[#F8F6F1] border-[#C9A84C]/20 text-gray-800 placeholder-gray-400'
    }`;

  return (
    <section id="contact" className={`py-24 transition-colors duration-300
      ${darkMode ? 'bg-[#080D1A]' : 'bg-[#F0EDE6]'}`}>
      <div className="container mx-auto px-4 lg:px-16">

        {/* Section Header */}
        <div className="mb-16 text-center">
          <p className={`text-xs font-medium tracking-[0.3em] uppercase mb-3
            ${darkMode ? 'text-[#C9A84C]/70' : 'text-[#8B6914]'}`}>
            Let's Talk
          </p>
          <h2 className={`text-4xl lg:text-5xl font-bold ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
            Get In <span className="text-[#C9A84C]">Touch</span>
          </h2>
          <div className="w-16 h-0.5 bg-[#C9A84C] mx-auto mt-5"></div>
          <p className={`mt-5 max-w-md mx-auto text-sm leading-relaxed
            ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Have a question or ready to start your financial journey? I'm here to help.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-5 gap-8">

          {/* Contact Info */}
          <div className="md:col-span-2">
            <div className={`p-7 rounded-2xl border h-full
              ${darkMode ? 'bg-[#0D1525] border-[#C9A84C]/10' : 'bg-white border-[#C9A84C]/20'}`}>

              <h3 className={`text-base font-semibold mb-6 flex items-center gap-2
                ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
                <span className="w-1 h-4 bg-[#C9A84C] rounded-full"></span>
                Contact Information
              </h3>

              <div className="space-y-5">
                {contacts.map((item, i) => (
                  <a key={i} href={item.href}
                    className={`flex items-start gap-3 group transition-colors`}>
                    <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors
                      ${darkMode
                        ? 'bg-[#C9A84C]/10 text-[#C9A84C] group-hover:bg-[#C9A84C] group-hover:text-[#0A0F1E]'
                        : 'bg-[#C9A84C]/15 text-[#8B6914] group-hover:bg-[#C9A84C] group-hover:text-[#0A0F1E]'
                      }`}>
                      {item.icon}
                    </div>
                    <div>
                      <p className={`text-xs font-medium ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>{item.label}</p>
                      <p className={`text-sm mt-0.5 transition-colors
                        ${darkMode
                          ? 'text-gray-300 group-hover:text-[#C9A84C]'
                          : 'text-gray-700 group-hover:text-[#8B6914]'
                        }`}>
                        {item.value}
                      </p>
                    </div>
                  </a>
                ))}
              </div>

              {/* Trust badge */}
              <div className={`mt-8 pt-6 border-t ${darkMode ? 'border-[#C9A84C]/10' : 'border-[#C9A84C]/15'}`}>
                <p className={`text-xs leading-relaxed ${darkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                  🔒 Your information is completely safe and will never be shared with third parties.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:col-span-3">
            <div className={`p-7 lg:p-8 rounded-2xl border
              ${darkMode ? 'bg-[#0D1525] border-[#C9A84C]/10' : 'bg-white border-[#C9A84C]/20'}`}>

              <h3 className={`text-base font-semibold mb-6 flex items-center gap-2
                ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
                <span className="w-1 h-4 bg-[#C9A84C] rounded-full"></span>
                Send a Message
              </h3>

              <form action="https://formspree.io/f/mvgazeoo" method="POST">
                <input type="hidden" name="_next" value="https://risecap.life/thankyou" />
                <input type="hidden" name="_captcha" value="false" />

                <div className="grid md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className={`block mb-1.5 text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Your Name
                    </label>
                    <input type="text" name="name" required placeholder="John Doe" className={inputClass(darkMode)} />
                  </div>
                  <div>
                    <label className={`block mb-1.5 text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Your Email
                    </label>
                    <input type="email" name="email" required placeholder="john@example.com" className={inputClass(darkMode)} />
                  </div>
                </div>

                <div className="mb-4">
                  <label className={`block mb-1.5 text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    Subject
                  </label>
                  <input type="text" name="subject" required placeholder="How can I help you?" className={inputClass(darkMode)} />
                </div>

                <div className="mb-6">
                  <label className={`block mb-1.5 text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    Your Message
                  </label>
                  <textarea name="message" rows="4" required placeholder="Write your message here..."
                    className={`${inputClass(darkMode)} resize-none`}>
                  </textarea>
                </div>

                <button type="submit"
                  className="group flex items-center gap-2 px-6 py-3 rounded-xl font-medium text-sm tracking-wide transition-all duration-300
                    bg-[#C9A84C] text-[#0A0F1E] hover:bg-[#E2C06A] shadow-lg shadow-[#C9A84C]/20 hover:shadow-[#C9A84C]/40">
                  Send Message
                  <Send size={15} className="group-hover:translate-x-0.5 transition-transform" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 